module.exports = __webpack_public_path__ + "img/img7.1198067d.svg";